import React from "react";
import styled from "styled-components";
import OtpInput from "react-otp-input";
import { Form, Row, Divider, Col } from "antd";
import { RAButtonPrimary, RATypography, RAButtonSecondary } from "@/components/customs";

const getReturnValues = (countDown) => {
	// calculate time left
	const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
	const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
	const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

	return { days, hours, minutes, seconds };
};

const template = ({
	userInfo,
	method,
	errors,
	otp,
	handleChangeOtp,
	countDown,
	onConfirmOTP,
	onBack,
	loading,
	sendCodeAgain,
}) => {
	const timer = getReturnValues(countDown);
	const focusStyle = {
		outlineColor: "#222222",
		color: "#222222",
		borderWidth: "1px",
	};
	return (
		<TemplateSection>
			<Form layout="vertical" className="form-login-wrapper">
				<FormInputWrapper>
					<TitleText>OTP Verification</TitleText>
					<SubTitleForgotPassword
						dangerouslySetInnerHTML={{
							__html: `A one time passcode has been sent to <b>${
								method === "email" ? userInfo?.email : userInfo?.phone || "_"
							}</b>`,
						}}
					/>
					<Divider />
					<WrapperValidIn>
						<ValidText>Code expired in:&nbsp;</ValidText>
						<ValidText color="#E73232">
							{`${timer.minutes > 0 ? String(timer.minutes).padStart(2, "0") : "00"}:${
								timer.seconds > 0 ? String(timer.seconds).padStart(2, "0") : "00"
							}`}
						</ValidText>
					</WrapperValidIn>
					<OtpInput
						value={otp}
						onChange={handleChangeOtp}
						numInputs={6}
						containerStyle={{
							justifyContent: "center",
							alignItems: "center",
						}}
						focusStyle={focusStyle}
						inputStyle={"input-otp"}
						separator={<span></span>}
					/>
					{errors && errors.otp && (
						<Row justify="center">
							<ErrorText>{errors.otp}</ErrorText>
						</Row>
					)}
					{countDown <= 0 && (
						<Row justify="center">
							<RATypography
								style={{ cursor: "pointer" }}
								variant="sub-heading4"
								top="20px"
								color="#595959"
								onClick={() => sendCodeAgain()}
							>
								Resend code
							</RATypography>
						</Row>
					)}

					<WrapperBottom justify="center" gutter={[20, 20]}>
						<Col>
							<RAButtonSecondary title="BACK" width="140px" onClick={onBack} disabled={countDown > 0} />
						</Col>
						<Col>
							<RAButtonPrimary
								title="CONFIRM"
								width="162px"
								onClick={() => onConfirmOTP()}
								loading={loading}
							/>
						</Col>
					</WrapperBottom>
				</FormInputWrapper>
			</Form>
		</TemplateSection>
	);
};

const TemplateSection = styled.div`
	padding-top: 30px;
	padding-bottom: 30px;
	width: 50vw;
	max-width: 620px;
	min-width: 343px;
	padding: clamp(24px, 8vw, 60px) clamp(16px, 4vw, 60px);
	.input-otp {
		margin: 0 8px;
		width: 42px !important;
		height: 42px;
		font-size: 18px;
		font-weight: 500;
		border-radius: 8px;
		border-width: 1px;
	}
	@media (max-width: 768px) {
		.input-otp {
			margin: 0 4px;
		}
	}
`;
const FormInputWrapper = styled.div`
	align-self: center;
`;
const SubTitleForgotPassword = styled.div`
	font-family: "DM Sans";
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 22px;
	color: #595959;
`;
const TitleText = styled.div`
	font-family: "Gilda Display";
	font-style: normal;
	font-weight: 400;
	font-size: 24px;
	line-height: 28px;
	text-transform: capitalize;
	color: #121216;
	margin-bottom: 20px;
	padding-left: 20px;
	border-left: 2px solid #ffb11a;
`;
const ErrorText = styled.div`
	padding-top: 20px;
	font-size: 14px;
	line-height: 14px;
	text-align: center;
	color: ${(props) => props.theme.color_status_error_500};
`;
const WrapperBottom = styled(Row)`
	margin-top: 40px;
`;
const ValidText = styled.div`
	color: ${(props) => props.color || "#595959"};
	font-family: "DM Sans";
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	text-align: center;
`;
const WrapperValidIn = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 20px;
`;

export { template };
